import React from "react";
import styles from "./index.css";

export default function Button({
  label,
  className,
  spaceBetween,
  type = "link",
  children,
  ...props
}) {
  return (
    <>
      {children && (
        <a className={`cicod-btn ${className}`} {...props}>
          {children}
          {spaceBetween && <span style={{ marginLeft: '5px' }}></span>} 
          {label}
          <i class="fa fa-home"></i>

        </a>
      )}
      {!children && type === "link" && (
        <a className={`cicod-btn ${className}`} {...props}>
          {label}
        </a>
      )}
      {!children && (type === "submit" || type === "button") && (
        <button type={type} className={`cicod-btn ${className}`} {...props} >
          {label}
        </button>
      )}
      {!children && type === "span-link" && (
        <a {...props}>
          <span className={`cicod-btn ${className}`}>{label}</span>
        </a>
      )}
      <style jsx>{styles}</style>
    </>
  );
}

export const RedButton = ({ size, className = "", ...props }) => (
  <Button
    className={`cicod-btn-red ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);

export const BlueButton = ({ size, className, ...props }) => (
  <Button
    className={`cicod-btn-blue ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);

export const WhiteBgButton = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-white-bg ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);


export const GreenButtonProfile = ({ size, className, ...props }) => (
  <Button
    className={`cicod-btn-green ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const GreenButton = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-green-new ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const GreenButtonLatest = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-green-latest ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const GreenButtonDeep = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-green-deep ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const OutlineButtonPlain = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-plain-outline ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const GreenButtonSmall = ({ size, className, link, ...props }) => (
  <Button
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-green-2 ${
      size && hasAttr(size) ? attr[size] : ""
    } ${className}`}
    {...props}
  />
);
export const WhiteButton = ({ size, className, ...props }) => (
  <Button
    className={`cicod-btn-white ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);

export const OutlineButton = ({
  label,
  color,
  size,
  className = "",
  ...props
}) => (
  <Button
    label={label}
    className={`cicod-btn-outline ${color}  ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);
export const OutlineButtonGray = ({
  label,
  color,
  link,
  size,
  className = "",
  ...props
}) => (
  
  <Button
    label={label}
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-outline-gray ${color}  ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />

);
export const OutlineButtonNew = ({
  label,
  link,
  color,
  size,
  className = "",
  ...props
}) => (
  <Button
    label={label}
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-outline-new ${color}  ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);
export const OutlineButtonLatest = ({
  label,
  link,
  color,
  size,
  className = "",
  ...props
}) => (
  <Button
    label={label}
    onClick={() => {
      location.href = `${link}`;
    }}
    className={`cicod-btn-outline-latest ${color}  ${size && hasAttr(size) ? attr[size] : ""
      } ${className}`}
    {...props}
  />
);

const attr = {
  small: "cicod-btn-sm",
  big: "cicod-btn-bg",
  large: "cicod-btn-lg",
  blue: "blue",
  red: "red",
};

const hasAttr = (a) => {
  try {
    let className = attr[a];
    return true;
  } catch (error) {
    return false;
  }
};

